module.exports = __webpack_public_path__ + "static/media/google-play@2x.1fc21aa3.png";